import * as React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

const colors = ['bg-blue-500', 'bg-emerald-500', 'bg-amber-500', 'bg-rose-500', 'bg-violet-500'];

function SlideCard({ index }: { index: number }) {
  return (
    <div className={`${colors[index]} flex h-40 items-center justify-center rounded-xl`}>
      <span className="text-2xl font-bold text-white">{index + 1}</span>
    </div>
  );
}

export function CarouselShowcase() {
  const variants = ['single-item', 'multiple-items'] as const;
  type CarouselVariant = (typeof variants)[number];

  const [variant, setVariant] = React.useState<CarouselVariant>('single-item');

  const variantMap: Record<
    CarouselVariant,
    { title: string; itemClassName?: string }
  > = {
    'single-item': { title: 'Single item' },
    'multiple-items': { title: 'Multiple items', itemClassName: 'basis-1/3' },
  };

  const activeVariant = variantMap[variant];

  return (
    <div className="space-y-4">
      <StateToggle
        options={variants}
        value={variant}
        onChange={setVariant}
        label="Variant"
        formatLabel={(value) =>
          value
            .split('-')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(' ')
        }
      />
      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">{activeVariant.title}</p>
        <Carousel>
          <CarouselPrevious />
          <CarouselContent>
            {colors.map((_, i) => (
              <CarouselItem key={i} className={activeVariant.itemClassName}>
                <SlideCard index={i} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNext />
        </Carousel>
      </div>
    </div>
  );
}
